import React from 'react';
import ScrollArea from "react-scrollbar";
import DocumentsSection from "../../components/DocumentsSection";

const CoverLetterTab = ({candidate, documents = []}) => {

    return (
        <React.Fragment>

            <ScrollArea
                speed={0.8}
                className="area"
                smoothScrolling={false}
                contentClassName="scroll-area cover-letter-area"
                stopScrollPropagation={true}
                horizontal={false}>
                <h3 className="proposal-tab-header">
                    Introduction
                </h3>
                {candidate.coverLetter() ? <div className="rich-text-display my-2">
                    <span dangerouslySetInnerHTML={{__html: candidate.coverLetter()}}/>
                </div> : (
                    <p className="my-2">Not specified</p>
                )}

                <hr/>

                <h3 className="proposal-tab-header">
                    Relevant Experience
                </h3>
                {candidate.relevantExperience() ? <div className="rich-text-display my-2">
                    <span dangerouslySetInnerHTML={{__html: candidate.relevantExperience()}}/>
                </div> : (
                    <p className="my-2">Not specified</p>
                )}

                <hr/>
                <h3 className="proposal-tab-header">
                    Supporting Documents
                </h3>

                <DocumentsSection
                    hideDetails={true}
                    emptyMessage="No Uploaded Documents Yet"
                    documents={candidate?.job_candidate?.talent_uploaded_proposals}/>
            </ScrollArea>


        </React.Fragment>
    );
};

export default CoverLetterTab;